import React from 'react';

type ThumbsDownFilledIconProps = {
  width?: string;
  height?: string;
  color?: string;
};

function ThumbsDownFilledIcon({
  width = '23',
  height = '22',
  color = '#6267AC',
}: ThumbsDownFilledIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 21 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.37486 5.07012C1.59709 3.62564 1.7082 2.90339 2.06227 2.36072C2.37433 1.88242 2.81643 1.50314 3.33661 1.26743C3.92682 1 4.65756 1 6.11904 1H16.801C17.9211 1 18.4812 1 18.909 1.21799C19.2853 1.40973 19.5913 1.71569 19.783 2.09202C20.001 2.51984 20.001 3.0799 20.001 4.2V8.8C20.001 9.9201 20.001 10.4802 19.783 10.908C19.5913 11.2843 19.2853 11.5903 18.909 11.782C18.4812 12 17.9211 12 16.801 12H16.0408C15.6645 12 15.4763 12 15.312 12.0592C15.1668 12.1115 15.0356 12.1967 14.9288 12.3082C14.808 12.4343 14.7316 12.6062 14.5787 12.9502L11.218 20.5119C11.086 20.8087 10.7917 21 10.4669 21C9.10502 21 8.00103 19.896 8.00103 18.5342V15.6C8.00103 15.0399 8.00103 14.7599 7.89204 14.546C7.79616 14.3578 7.64318 14.2049 7.45502 14.109C7.24111 14 6.96108 14 6.40103 14H5.59596C3.66836 14 2.70456 14 2.01495 13.6079C1.40968 13.2637 0.942971 12.7197 0.694833 12.0691C0.412121 11.3279 0.558674 10.3753 0.851779 8.47012L1.37486 5.07012Z'
        fill={color}
      />
      <path
        d='M15.001 1V12M20.001 8.8V4.2C20.001 3.07989 20.001 2.51984 19.783 2.09202C19.5913 1.71569 19.2853 1.40973 18.909 1.21799C18.4812 1 17.9211 1 16.801 1H6.11904C4.65756 1 3.92682 1 3.33661 1.26743C2.81643 1.50314 2.37433 1.88242 2.06227 2.36072C1.7082 2.90339 1.59709 3.62564 1.37486 5.07012L0.851779 8.47012C0.558674 10.3753 0.412121 11.3279 0.694833 12.0691C0.942971 12.7197 1.40968 13.2637 2.01495 13.6079C2.70456 14 3.66836 14 5.59596 14H6.40103C6.96108 14 7.24111 14 7.45502 14.109C7.64318 14.2049 7.79616 14.3578 7.89204 14.546C8.00103 14.7599 8.00103 15.0399 8.00103 15.6V18.5342C8.00103 19.896 9.10502 21 10.4669 21C10.7917 21 11.086 20.8087 11.218 20.5119L14.5787 12.9502C14.7316 12.6062 14.808 12.4343 14.9288 12.3082C15.0356 12.1967 15.1668 12.1115 15.312 12.0592C15.4763 12 15.6645 12 16.0408 12H16.801C17.9211 12 18.4812 12 18.909 11.782C19.2853 11.5903 19.5913 11.2843 19.783 10.908C20.001 10.4802 20.001 9.9201 20.001 8.8Z'
        stroke='white'
        stroke-width='0.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default ThumbsDownFilledIcon;
